module.exports = __webpack_public_path__ + "fonts/Roboto-Black.3f6ebbe.woff2";